import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = SVGIconProps & { className?: string };

export const BarChartBoardIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <g clipPath="url(#clip0_3222_21539)">
          <path
            d="M8.00033 4.16602H6.33366C5.89163 4.16602 5.46771 4.34161 5.15515 4.65417C4.84259 4.96673 4.66699 5.39065 4.66699 5.83268V15.8327C4.66699 16.2747 4.84259 16.6986 5.15515 17.0112C5.46771 17.3238 5.89163 17.4993 6.33366 17.4993H14.667C15.109 17.4993 15.5329 17.3238 15.8455 17.0112C16.1581 16.6986 16.3337 16.2747 16.3337 15.8327V5.83268C16.3337 5.39065 16.1581 4.96673 15.8455 4.65417C15.5329 4.34161 15.109 4.16602 14.667 4.16602H13.0003"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.3333 2.5H9.66667C8.74619 2.5 8 3.24619 8 4.16667C8 5.08714 8.74619 5.83333 9.66667 5.83333H11.3333C12.2538 5.83333 13 5.08714 13 4.16667C13 3.24619 12.2538 2.5 11.3333 2.5Z"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 14.1667V10"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 14.1673V13.334"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13 14.166V11.666"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.00033 4.16602H6.33366C5.89163 4.16602 5.46771 4.34161 5.15515 4.65417C4.84259 4.96673 4.66699 5.39065 4.66699 5.83268V15.8327C4.66699 16.2747 4.84259 16.6986 5.15515 17.0112C5.46771 17.3238 5.89163 17.4993 6.33366 17.4993H14.667C15.109 17.4993 15.5329 17.3238 15.8455 17.0112C16.1581 16.6986 16.3337 16.2747 16.3337 15.8327V5.83268C16.3337 5.39065 16.1581 4.96673 15.8455 4.65417C15.5329 4.34161 15.109 4.16602 14.667 4.16602H13.0003"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 14.1673V13.334"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13 14.166V11.666"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3222_21539">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
